/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomFamilyFilter
 */
export interface CustomFamilyFilter {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof CustomFamilyFilter
     */
    caseInsensitive?: { [key: string]: boolean; };
    /**
     * 
     * @type {string}
     * @memberof CustomFamilyFilter
     */
    familyType?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomFamilyFilter
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomFamilyFilter
     */
    searchText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFamilyFilter
     */
    status?: boolean;
}

/**
 * Check if a given object implements the CustomFamilyFilter interface.
 */
export function instanceOfCustomFamilyFilter(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CustomFamilyFilterFromJSON(json: any): CustomFamilyFilter {
    return CustomFamilyFilterFromJSONTyped(json, false);
}

export function CustomFamilyFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomFamilyFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'caseInsensitive': !exists(json, 'caseInsensitive') ? undefined : json['caseInsensitive'],
        'familyType': !exists(json, 'familyType') ? undefined : json['familyType'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'searchText': !exists(json, 'searchText') ? undefined : json['searchText'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function CustomFamilyFilterToJSON(value?: CustomFamilyFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'caseInsensitive': value.caseInsensitive,
        'familyType': value.familyType,
        'name': value.name,
        'searchText': value.searchText,
        'status': value.status,
    };
}

